import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { CookieService as NgxCookieService } from "ngx-cookie-service";

@Injectable({ providedIn: "root" })
export class CookieService {
  private _valueSubject: Subject<string> = new Subject<string>();

  constructor(private _cookieService: NgxCookieService) {}

  public set(key: string, newValue: string, expiresIn?: number, path?: string): void {
    this._cookieService.set(key, newValue, expiresIn, path);
    this._valueSubject.next(newValue);
  }

  public get(key: string): string | null {
    return this._cookieService.get(key) ?? null;
  }

  public observeValue(): Observable<string> {
    return this._valueSubject.asObservable();
  }
}
